const bookingArrangementItems = document.querySelectorAll('.booking-item');
const arrangementIdInput = document.getElementById('input-arrangement-id');
const yourSelectionList = document.querySelector('.tw-your-selection > .your-selection-list');
const yourSelectionPlaceholder = document.querySelector('.your-selection-placeholder');
let arrangements = [];

export function arrayRemove(arr, value) {
    return arr.filter((ele) => ele !== value);
}

export function unsetAllValuesInCurrentCategory(categoryWrapper) {
    const categoryBookingItems = categoryWrapper.querySelectorAll('.booking-item');

    categoryBookingItems.forEach((elementCatBooking) => {
        const dataIdCatBooking = elementCatBooking.getAttribute('data-id');

        elementCatBooking.classList.remove('booking-item-checked');
        arrangements = arrayRemove(arrangements, dataIdCatBooking);
        arrangementIdInput.value = arrangements.join('||');
        const selectionToRemove = yourSelectionList.querySelector(`[data-id="${dataIdCatBooking}"]`);
        if (selectionToRemove) {
            selectionToRemove.parentNode.removeChild(selectionToRemove);
        }
    });
}

export function updateBookingItems(currentTarget) {
    const dataId = currentTarget.getAttribute('data-id');
    const categoryWrapper = currentTarget.closest('.tw-reservation-item-wrapper');
    const categoryName = currentTarget.getAttribute('data-category');
    const selectedProductName = currentTarget.querySelector('.tw-block-title > .title').innerHTML;
    let selectedProductPrice = '';
    if (currentTarget.querySelector('.tw-block-prices > .tw-block-price')) {
        selectedProductPrice = currentTarget.querySelector('.tw-block-prices > .tw-block-price').innerHTML;
    }

    // Always hide the initial p-tag in the selection panel
    yourSelectionPlaceholder.classList.add('hidden');

    if (categoryName !== 'Activiteiten') {
        unsetAllValuesInCurrentCategory(categoryWrapper);
    }

    // eslint-disable-next-line max-len
    // When it's not the none option, add or remove the element from the arrangements input
    if (!currentTarget.classList.contains('booking-item-placeholder')) {
        const bookingItemPlaceholder = categoryWrapper.querySelector('.booking-item-placeholder');
        bookingItemPlaceholder.classList.remove('booking-item-checked');

        if (!currentTarget.classList.contains('booking-item-checked')) {
            currentTarget.classList.add('booking-item-checked');
            arrangements.push(dataId);
            arrangementIdInput.value = arrangements.join('||');
            yourSelectionList.innerHTML += `<li data-id="${dataId}"><span>${selectedProductName}</span><span>${selectedProductPrice}</span></li>`;
        } else {
            currentTarget.classList.remove('booking-item-checked');
            arrangements = arrayRemove(arrangements, dataId);
            arrangementIdInput.value = arrangements.join('||');
            const selectionToRemove = yourSelectionList.querySelector(`[data-id="${dataId}"]`);
            if(selectionToRemove) {
              selectionToRemove.parentNode.removeChild(selectionToRemove);
            }
        }
    } else {
        // eslint-disable-next-line max-len
        // When it's the none option, remove all category related items from the arrangements input
        unsetAllValuesInCurrentCategory(categoryWrapper);

        currentTarget.classList.add('booking-item-checked');
    }

    if (arrangements.length == 0) {
        yourSelectionPlaceholder.classList.remove('hidden');
    } else {
        yourSelectionPlaceholder.classList.add('hidden');
    }
}

export default function initBookingForm() {
    if (bookingArrangementItems) {
        // eslint-disable-next-line max-len
        // When an arrangement is selected on page load, assign this arrangement to current selection panel
        const checkedItems = document.querySelectorAll('.booking-item-checked  ');
        checkedItems.forEach((element) => {
          const dataId = element.getAttribute('data-id');
          const selectedProductName = element.querySelector('.tw-block-title > .title').innerHTML;
          let selectedProductPrice = '';
          if (element.querySelector('.tw-block-prices > .tw-block-price')) {
            selectedProductPrice = element.querySelector('.tw-block-prices > .tw-block-price').innerHTML;
          }

          arrangements.push(dataId);
          arrangementIdInput.value = arrangements.join('||');
          yourSelectionList.innerHTML += `<li data-id="${dataId}"><span>${selectedProductName}</span><span>${selectedProductPrice}</span></li>`;
        });

        // Click event for each booking item on reservation page
        bookingArrangementItems.forEach((element) => {
            element.addEventListener('click', (e) => {
                e.stopPropagation();
                updateBookingItems(e.currentTarget);
            });
        });
    }
}
